import React from 'react';

import { observer } from 'mobx-react-lite';

import { airlineMileageProgramMap } from '^/constants/airlineMileageProgram';
import { MARGINS, font2 } from '^/constants/commonStyles';
import { ReservationDetailed } from '^/types/ReservationDetailed/RawReservationDetailed';

import { flexSplitHorizontalInHalf } from './ReservationDetailDesktop.commonStuff';
import { Horizon } from '^/pages/ReservationList/components/common/Horizon';

export const ReservationDetailsDriverInfoMemberships: React.FC<{
  data: ReservationDetailed;
}> = observer(function ReservationDetailsDriverInfoMemberships({ data }) {
  return (
    <div>
      {(data?.hertz_membership ||
        data?.flight_number ||
        (data?.frequent_flyer && data.frequent_brand)) && (
        <Horizon marginTop="30px" marginBottom="30px" height="1px" />
      )}

      {data?.hertz_membership && (
        <div>
          <h2 className={[font2.Title3].join(' ')}>허츠 골드 멤버십</h2>
          <p className={[font2.Caption1_Bold, MARGINS.TOP.spacing32].join(' ')}>회원번호</p>
          <p className={[font2.Caption1_Light, MARGINS.TOP.spacing12].join(' ')}>
            {data.hertz_membership || '-'}
          </p>
        </div>
      )}

      <div className={[MARGINS.TOP.spacing48].join(' ')}>
        <h2 className={font2.Title3}>도착 비행기 정보</h2>
        <div className={[flexSplitHorizontalInHalf].join(' ')}>
          {data.flight_brand && (
            <div>
              <p className={[font2.Caption1_Bold, MARGINS.TOP.spacing32].join(' ')}>항공사</p>
              <p className={[font2.Caption1_Light, MARGINS.TOP.spacing12].join(' ')}>
                {data.flight_brand || '-'}
              </p>
            </div>
          )}
          <div>
            <p className={[font2.Caption1_Bold, MARGINS.TOP.spacing32].join(' ')}>항공편명</p>
            <p className={[font2.Caption1_Light, MARGINS.TOP.spacing12].join(' ')}>
              {data.flight_number || '-'}
            </p>
          </div>
        </div>
      </div>

      {data.frequent_flyer && data.frequent_brand && (
        <div className={[MARGINS.TOP.spacing48].join(' ')}>
          <h2 className={[font2.Title3].join(' ')}>항공 마일리지 적립</h2>
          <div className={[flexSplitHorizontalInHalf].join(' ')}>
            <div>
              <p className={[font2.Caption1_Bold, MARGINS.TOP.spacing32].join(' ')}>
                항공 마일리지 제휴사
              </p>
              <p className={[font2.Caption1_Light, MARGINS.TOP.spacing12].join(' ')}>
                {airlineMileageProgramMap.get(data.frequent_brand)?.name || '-'}
              </p>
            </div>
            <div>
              <p className={[font2.Caption1_Bold, MARGINS.TOP.spacing32].join(' ')}>
                제휴사 회원번호
              </p>
              <p className={[font2.Caption1_Light, MARGINS.TOP.spacing12].join(' ')}>
                {data.frequent_flyer || '-'}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
